<div
    class="section-padding-vertical-md lg:section-padding-vertical-lg w-full flex flex-col gap items-center">
    <div class="w-full flex flex-col items-center gap-6">
        <h2>{{ heading() }}</h2>
        @if (subheader()) {
            <p class="max-w-screen-sm text-center">
                {{ subheader() }}
            </p>
        }
    </div>

    <div class="max-w-screen-md">
        <mat-accordion class="flex flex-col gap-6">
            @for (item of items(); track item) {
                <mat-expansion-panel
                    class="!rounded-medium !bg-muted border-2 border-muted-dark !h-auto">
                    <mat-expansion-panel-header class="!h-auto !p-6">
                        <mat-panel-title class="!font-normal !text-dark">
                            {{ item.question }}</mat-panel-title
                        >
                    </mat-expansion-panel-header>
                    <p class="!p-6 !pt-0">{{ item.answer }}</p>
                </mat-expansion-panel>
            }
        </mat-accordion>
    </div>
</div>
